import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { addNotification } from '.'

export const useAddNotification = () => {
  const dispatch = useDispatch()
  return useCallback((notice: Parameters<typeof addNotification>[0]) => dispatch(addNotification(notice)), [dispatch])
}
